export default "__VITE_ASSET__DqB3ivpB__"